








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BasicsInfo from './modules/basicsInfo.vue';
import Graphic from './modules/graphic.vue';
import PriceStock from './modules/priceStock.vue';
import Performance from './modules/performance.vue';
import rulesConfig from './rulesConfig';
import { addGoods1, editGoods, goodsDetail, backendCheck, goodsCopyDetail } from '@/utils/api';
import { v4 as uuidv4 } from 'uuid';
import { nextTick, observable } from 'vue/types/umd';
// import { jumpPage } from '@/utils/index';
let xss = require('xss');

@Component({
  components: {
    BasicsInfo,
    Graphic,
    PriceStock,
    Performance
  }
})
export default class GoodsInfo extends Vue {
  $refs: any;
  $get: any;
  @Prop(Object) categories!: object;
  @Watch('categories', { immediate: true, deep: true })
  onPersonChanged(val: object) {
    if (val['categoryId']) {
      this.formData['categoryName'] = val['categoryName'];
      this.formData['selectedName'] = val['selectedName'];
      this.formData['categoryId'] = val['categoryId'];
      this.modelIsShow();
    }
  }

  saveLoading: boolean = false; //按钮加载状态
  isTmpSave: boolean = false; //是否展示暂存按钮
  isFixed: boolean = false; //是否展示吸顶
  offsetTop: number = 0; //距离顶部的高度
  basicsInfoTop: number = 0; //基本信息距离顶部的高度
  graphicTop: number = 0; //图文信息距离顶部的高度
  priceStockTop: number = 0; //图文信息距离顶部的高度
  performanceTop: number = 0; //图文信息距离顶部的高度
  mold: number = 1; //选中哪个模块
  rules = rulesConfig; //表单效验规则
  isAdded: boolean = true; //是否为新增商品
  allData: object = {}; //接收全部数据
  basicsInfoIsShow: boolean = false; //基础模块是否显示
  graphicIsShow: boolean = false; //图形模块
  priceStockIsShow: boolean = false; //sku模块
  performanceIsShow: boolean = false; //服务模块
  loading: boolean = true;
  // 表单数据
  formData: object = {
    brandId: '', //品牌id
    categoryName: [],
    selectedName: '',
    categoryId: [],
    spuName: '', //spu名称
    spuId: '',
    spuSkuImages: [], //spu图片组
    spuCode: '', //商品编码
    info: '', //spu富文本信息
    commoditySkuInfo: [
      {
        spuId: '',
        deleted: false,
        modifiedDate: '',
        modifiedBy: {},
        createdDate: '',
        createdBy: {},
        id: '',
        skuNameTitle: '',
        skuCode: '',
        suggestCostPrice: undefined, //成本价格
        suggestMarketPrice: undefined, //市场销售价
        hight: 0, //高 mm
        length: 0, //长 mm
        published: 1, //发布标识 0:未发布，1:发布
        saleUnit: '', //单位
        skuId: '', //sku_id
        skuName: '', //sku名称
        taxRate: 0, //税率
        weight: 0, //重量kg
        width: 0, //宽 mm
        skuSpecifications: [],
        skuStock: {
          //商品SKU库存
          curStock: 0, //可用库存
          preStock: 0, //预占库存
          stockCount: undefined, //库存总量
          version: 0 //版本
        },
        isEnable: true,
        spuSkuImages: [], //SKU图片存储
        barCode: '', //产品条码
        productModel: '', //产品型号
        orderNo: '' //订单编号
      }
    ], //sku信息
    stepSize: 1, //步长值
    minOrderQuantity: 1, //起订量
    serviceInfo: {
      //服务与履约
      logisticsTempId: '' //物流模板id
    },
    published: 1, //spu上下架 0下架1上架
    specificationItems: [], //规格数据,
    categoryParams: []
  };
  $bus: any;

  /* 类目属性选中信息 */
  categoryParams(data) {
    this.formData['categoryParams'] = data;
  }

  /* 元素距离顶部的高度 */
  elOffsetTop() {
    this.$nextTick(function() {
      this.offsetTop = this.$refs.partitionFixed.offsetTop == 0 ? 127 : this.$refs.partitionFixed.offsetTop;
      this.basicsInfoTop = this.$refs.basicsInfo.$el.offsetTop - 41;
      this.graphicTop = this.$refs.graphic.$el.offsetTop - 41;
      this.priceStockTop = this.$refs.priceStock.$el.offsetTop - 41;
      this.performanceTop = this.$refs.performance.$el.offsetTop - 41;
      (document.querySelector('.fin-main') || window).addEventListener('scroll', this.handleScroll);
      this.handleScroll();
    });
  }
  /* 滚动到指定位置 */
  handleScroll() {
    let scrollTop = document.querySelector('.fin-main').scrollTop || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    this.isFixed = scrollTop > this.basicsInfoTop ? true : false;
    let basicsInfoTop = this.basicsInfoTop;
    let graphicTop = this.graphicTop;
    let priceStockTop = this.priceStockTop;
    let performanceTop = this.performanceTop;
    if (scrollTop >= basicsInfoTop) this.mold = 1;
    if (scrollTop >= graphicTop) this.mold = 2;
    if (scrollTop >= priceStockTop) this.mold = 3;
    if (scrollTop >= performanceTop) this.mold = 4;
  }
  // 滚动到指定区域
  rollSite(num, type) {
    (document.querySelector('.fin-main') || window).scrollTo({
      top: num,
      behavior: 'smooth'
    });
  }
  // skul列表数据
  commoditySkuInfoTo(data) {
    this.formData['commoditySkuInfo'] = data;
  }
  /* 商品详情 */
  goodsDetail(spuId) {
    goodsDetail({ spuId }).then((data: any) => {
      this.receiveConversionData(data);
    });
  }
  /* 复制商品数据详情 */
  goodsCopyDetail(spuId) {
    goodsCopyDetail({ spuId }).then((data: any) => {
      this.receiveConversionData(data);
    });
  }
  // 点击保存数据
  submitForm(formName) {
    let tableData = this.formData['commoditySkuInfo'];
    this.$refs[formName].validate(valid => {
      if (valid) {
        let num = 0;
        for (let i = 0; i < tableData.length; i++) {
          const element = tableData[i];
          if (!element['suggestCostPrice']) {
            this.$message.error(`价格库存列表第${i + 1}行为空,请输入供货价（元）`);
            num++;
            break;
          } else if (!element['suggestMarketPrice']) {
            this.$message.error(`价格库存列表第${i + 1}行为空,请输入市场售价（元）`);
            num++;
            break;
          } else if (element['skuStock']['stockCount'] < 0) {
            this.$message.error(`价格库存列表第${i + 1}行为空,请输入库存`);
            num++;
            break;
          }
        }
        if (num === 0) {
          this.sendConversionData(0);
        }
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  /* 暂存数据 */
  temporaryData() {
    let spuName = this.formData['spuName'];
    if (spuName == '') {
      this.$message.error('请输入商品标题');
    } else {
      this.sendConversionData(1);
    }
  }
  /* 发送数据转化 */
  sendConversionData(tmpSave) {
    let formData = this.formData;
    let commodityBasicInfo = {};
    let categoryParams = formData['categoryParams'];
    let commoditySkuInfo = formData['commoditySkuInfo'];
    let serviceInfo = formData['serviceInfo'];
    if (!this.isAdded) {
      commodityBasicInfo = this.allData['commodityBasicInfo'];
      (commodityBasicInfo['catOneId'] = formData['categoryId'][0]),
        (commodityBasicInfo['catTwoId'] = formData['categoryId'][1]),
        (commodityBasicInfo['catThreeId'] = formData['categoryId'][2]),
        (commodityBasicInfo['catOneName'] = formData['categoryName'][0]),
        (commodityBasicInfo['catTwoName'] = formData['categoryName'][1]),
        (commodityBasicInfo['catThreeName'] = formData['categoryName'][2]),
        (commodityBasicInfo['spuName'] = formData['spuName']);
      commodityBasicInfo['spuCode'] = formData['spuCode'];
      commodityBasicInfo['spuSkuImages'] = formData['spuSkuImages'];
      if (commodityBasicInfo['brandId'] && commodityBasicInfo['brandId']['brandId']) {
        commodityBasicInfo['brandId']['brandId'] = formData['brandId'];
      } else {
        if (formData['brandId'] != '') {
          commodityBasicInfo['brandId'] = { brandId: formData['brandId'] };
        }
      }
      if (commodityBasicInfo['largeText'] && commodityBasicInfo['largeText']['info']) {
        commodityBasicInfo['largeText']['info'] = formData['info'];
      } else {
        if (formData['info'] != '') {
          commodityBasicInfo['largeText'] = { info: formData['info'] };
        }
      }
      commodityBasicInfo['spuId'] = formData['spuId'];
      commodityBasicInfo['minOrderQuantity'] = formData['minOrderQuantity'];
      commodityBasicInfo['stepSize'] = formData['stepSize'];
      commodityBasicInfo['published'] = formData['published'];
      commodityBasicInfo['tmpSave'] = tmpSave;
    } else {
      let basicInfo = {
        catOneId: formData['categoryId'][0],
        catTwoId: formData['categoryId'][1],
        catThreeId: formData['categoryId'][2],
        catOneName: formData['categoryName'][0],
        catTwoName: formData['categoryName'][1],
        catThreeName: formData['categoryName'][2],
        spuName: formData['spuName'],
        spuCode: formData['spuCode'],
        spuSkuImages: formData['spuSkuImages'],
        largeText: {
          info: formData['info']
        },
        brandId: {
          brandId: formData['brandId']
        },
        spuId: formData['spuId'],
        minOrderQuantity: formData['minOrderQuantity'],
        stepSize: formData['stepSize'],
        published: formData['published'],
        tmpSave
      };
      commodityBasicInfo = basicInfo;
    }
    let data = { commodityBasicInfo, commoditySkuInfo, serviceInfo, categoryParams };
    this.backendCheck({ catThreeId: formData['categoryId'][2] }, data);
  }
  /* 类目是否存在 */
  backendCheck(catThreeId, datas) {
    backendCheck(catThreeId).then((data: any) => {
      if (data) {
        let copy = this.$route.query.copy;
        if (copy) {
          datas.commodityBasicInfo['spuId'] = null;
          this.addGoods1(datas);
        } else {
          this.isAdded ? this.addGoods1(datas) : this.editGoods(datas);
        }
      } else {
        this.$message.error('您选择的类目未授权，请选择其他类目');
      }
    });
  }
  /* 新增数据 */
  addGoods1(data) {
    this.saveLoading = true;
    addGoods1(data)
      .then((data: any) => {
        this.jumpPath('商品新增成功！');
      })
      .catch(err => {
        this.saveLoading = false;
      });
  }
  /* 编辑数据 */
  editGoods(data) {
    this.saveLoading = true;
    editGoods(data)
      .then((data: any) => {
        this.jumpPath('商品编辑成功！');
      })
      .catch(err => {
        this.saveLoading = false;
      });
  }
  /* 跳转页面 */
  jumpPath(txt) {
    this.$message({
      message: txt,
      type: 'success'
    });
    setTimeout(() => {
      // jumpPage('goods', 'goodsManage', '/goods/goodsManage/goodsManage');
      this.$router.push({ path: '/goods/goodsManage/goodsManage', query: {} });
      this.saveLoading = false;
    }, 2000);
  }
  /* 接收数据转化 */
  receiveConversionData(data) {
    this.$store.commit('INFO', '');
    this.allData = data;
    let get = this.$get;
    let formData = this.formData;
    let commodityBasicInfo = data['commodityBasicInfo'];
    let serviceInfo = data['serviceInfo'];
    let commoditySkuInfo = data['commoditySkuInfo'];
    let categoryParams = data['categoryParams'];
    formData['categoryName'] = [commodityBasicInfo['catOneName'], commodityBasicInfo['catTwoName'], commodityBasicInfo['catThreeName']];
    formData[
      'selectedName'
    ] = `${commodityBasicInfo['catOneName']} > ${commodityBasicInfo['catTwoName']} > ${commodityBasicInfo['catThreeName']}`;
    formData['categoryId'] = [commodityBasicInfo['catOneId'], commodityBasicInfo['catTwoId'], commodityBasicInfo['catThreeId']];
    formData['spuName'] = commodityBasicInfo['spuName'];
    formData['spuSkuImages'] = get(commodityBasicInfo, 'spuSkuImages', []);
    formData['spuCode'] = get(commodityBasicInfo, 'spuCode', '');
    if (commodityBasicInfo['largeText']) {
      if (commodityBasicInfo['largeText']['info']) {
        formData['info'] = commodityBasicInfo['largeText']['info'];
      } else {
        formData['info'] = '';
      }
    } else {
      formData['info'] = '';
    }
    formData['stepSize'] = commodityBasicInfo['stepSize'];
    formData['minOrderQuantity'] = commodityBasicInfo['minOrderQuantity'];
    formData['published'] = commodityBasicInfo['published'];
    formData['serviceInfo'] = serviceInfo;
    formData['brandId'] = get(commodityBasicInfo, 'brandId.brandId', '');

    commoditySkuInfo.sort((a, b) => {
      if (a?.skuSpecifications && a?.skuSpecifications.length && b?.skuSpecifications && b?.skuSpecifications.length) {
        return a['skuSpecifications'][0]['specItemValue'].localeCompare(b['skuSpecifications'][0]['specItemValue']);
      }
    });

    commoditySkuInfo.forEach(item => {
      item['uuid'] = uuidv4();
      if (!item['suggestCostPrice']) item['suggestCostPrice'] = undefined;
      if (!item['suggestMarketPrice']) item['suggestMarketPrice'] = undefined;
      if (!(item['skuStock'] && (item['skuStock']['stockCount'] || item['skuStock']['stockCount'] == 0))) {
        item['skuStock'] = {
          curStock: 0,
          preStock: 0,
          stockCount: undefined,
          version: 0
        };
      }
      let skuNameTitle = '';
      item['skuSpecifications'].forEach(el => {
        skuNameTitle += el['specItemValue'] + ',';
      });
      item['skuNameTitle'] = skuNameTitle;
    });
    formData['commoditySkuInfo'] = commoditySkuInfo;
    commodityBasicInfo['specificationItems'].forEach(item => {
      item['specificationValues'].forEach(el => {
        el['specsValId'] = uuidv4();
      });
    });
    formData['specificationItems'] = commodityBasicInfo['specificationItems'];
    formData['categoryParams'] = categoryParams;
    if (commodityBasicInfo['tmpSave']) {
      this.isTmpSave = true;
    }
    this.modelIsShow();
  }
  // 模块显示
  modelIsShow() {
    this.loading = false;
    this.basicsInfoIsShow = true;
    this.graphicIsShow = true;
    this.priceStockIsShow = true;
    this.performanceIsShow = true;
    this.elOffsetTop();
  }
  /* 取消操作 */
  cancel() {
    // jumpPage('goods', 'goodsManage', '/goods/goodsManage/goodsManage');
    this.$router.push({ path: '/goods/goodsManage/goodsManage', query: {} });
  }
  /* 初始化数据 */
  init() {
    let formData = this.formData;
    formData['brandId'] = '';
    formData['categoryName'] = [];
    formData['selectedName'] = '';
    formData['categoryId'] = [];
    formData['spuId'] = '';
    formData['spuName'] = '';
    formData['spuSkuImages'] = [];
    formData['spuCode'] = '';
    formData['stepSize'] = 1;
    formData['minOrderQuantity'] = 1;
    formData['serviceInfo']['logisticsTempId'] = '';
    formData['published'] = 1;
    formData['specificationItems'] = [];
    formData['categoryParams'] = [];
    formData['info'] = '';
    let commoditySkuInfo = [
      {
        skuNameTitle: '',
        skuCode: '',
        suggestCostPrice: undefined, //成本价格
        suggestMarketPrice: undefined, //市场销售价
        hight: 0, //高 mm
        length: 0, //长 mm
        published: 1, //发布标识 0:未发布，1:发布
        saleUnit: '', //单位
        skuId: '', //sku_id
        skuName: '', //sku名称
        taxRate: 0, //税率
        weight: 0, //重量kg
        width: 0, //宽 mm
        skuSpecifications: [],
        skuStock: {
          //商品SKU库存
          curStock: 0, //可用库存
          preStock: 0, //预占库存
          stockCount: undefined, //库存总量
          version: 0 //版本
        },
        isEnable: true,
        spuSkuImages: [], //SKU图片存储
        barCode: '', //产品条码
        productModel: '', //产品型号
        orderNo: '' //订单编号
      }
    ];
    formData['commoditySkuInfo'] = commoditySkuInfo;
    this.basicsInfoIsShow = false;
    this.graphicIsShow = false;
    this.priceStockIsShow = false;
    this.performanceIsShow = false;
    this.isAdded = true;
    this.isTmpSave = true;
  }

  created() {
    let spuId = this.$route.query.spuid;
    let copy = this.$route.query.copy;
    if (spuId) {
      this.isAdded = false;
      this.formData['spuId'] = spuId;
      if (copy) {
        this.isTmpSave = true;
        this.goodsCopyDetail(spuId);
      } else {
        this.goodsDetail(spuId);
        this.isTmpSave = false;
      }
    } else {
      this.isAdded = true;
      this.isTmpSave = true;
    }
  }
}
